import React, { useState } from "react";
import axios from "axios";
import bgImage from "../assets/arma-bg.jpg";

const API = "";

export default function LoginView({ onLogin }) {

  const [credentials, setCredentials] = useState({
    username: "",
    password: ""
  });

  const [error, setError] = useState("");

  const login = () => {
    setError("");

    axios.post(`${API}/api/login`, credentials)
      .then(res => {
        if (res.data.success) {
          onLogin();
        } else {
          setError("Invalid credentials");
        }
      })
      .catch(() => setError("Invalid credentials"));
  };

  return (
    <div style={styles.container}>

      <div style={styles.overlay} />

      <div style={styles.loginCard}>

        <h1 style={styles.title}>ARMA REFORGER</h1>
        <p style={styles.subtitle}>Server Control Panel</p>

        <input
          style={styles.input}
          placeholder="Username"
          value={credentials.username}
          onChange={e =>
            setCredentials({ ...credentials, username: e.target.value })
          }
        />

        <input
          type="password"
          style={styles.input}
          placeholder="Password"
          value={credentials.password}
          onChange={e =>
            setCredentials({ ...credentials, password: e.target.value })
          }
        />

        {error && (
          <div style={styles.error}>
            {error}
          </div>
        )}

        <button style={styles.button} onClick={login}>
          LOGIN
        </button>

      </div>
    </div>
  );
}

const styles = {

  container: {
    height: "100vh",
    width: "100vw",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    fontFamily: "Arial, sans-serif"
  },

  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(10,15,20,0.85)"
  },

  loginCard: {
    position: "relative",
    zIndex: 2,
    width: 350,
    padding: 40,
    borderRadius: 8,
    background: "rgba(20,25,30,0.95)",
    border: "1px solid #2a2f3a",
    boxShadow: "0 0 30px rgba(0,0,0,0.7)",
    display: "flex",
    flexDirection: "column",
    gap: 15
  },

  title: {
    color: "#3ccf91",
    textAlign: "center",
    marginBottom: 0,
    letterSpacing: 2
  },

  subtitle: {
    color: "#aaa",
    textAlign: "center",
    marginTop: 0,
    marginBottom: 20,
    fontSize: 14
  },

  input: {
    padding: 12,
    borderRadius: 4,
    border: "1px solid #2a2f3a",
    background: "#0f1117",
    color: "#fff",
    outline: "none"
  },

  button: {
    padding: 12,
    background: "#3ccf91",
    border: "none",
    borderRadius: 4,
    fontWeight: "bold",
    cursor: "pointer",
    letterSpacing: 1
  },

  error: {
    color: "#ff4c4c",
    fontSize: 13,
    textAlign: "center"
  }

};
